// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"32ae3716","429":"e0b4804f","453":"5148b974"}[chunkId] + ".chunk.js";
};